import React from "react";

const FormInput = ({
  placeholder,
  onChange,
  isInvalid,
  onFocus,
  value,
  disabled,
  label,
  name,
}) => {
  return (
    <div>
      {label && <p className="mb-1.5 text-xs text-monochrome-400">{label}</p>}
      <input
        name={name}
        type="text"
        className={`form-input ${isInvalid && "!border-danger"} block h-12 w-full disabled:text-monochrome-300`}
        onChange={onChange}
        onFocus={onFocus}
        value={value}
        disabled={disabled}
        placeholder={placeholder}
        required
      />
      {isInvalid && (
        <div className="mt-0.5 text-2xs text-rose-500">{isInvalid}</div>
      )}
    </div>
  );
};

export default FormInput;
